import BuildOptionsForm from '@staticsnap/dashboard/components/build-options/build-options-form';

export default function BuildOptionsIndex() {
  return <BuildOptionsForm title="Build options" />;
}
